import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkname: "dweb-app-promo-page" */ './Container'));
